module.exports = __webpack_public_path__ + "img/ico-add-white.7da27060.svg";